(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zip-shipping-check"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zip-shipping-check')) {
    const STORAGE_KEY = 'zip-shipping-check:last';
    const LOCK_TARGETS = '.add-to-cart-button, .accelerated-checkout-block';

    /**
     * Keeps the purchase buttons of a section locked while any zip block that
     * requires a zip has no matching zip. Uses `inert` rather than `disabled`
     * so the theme's own sold-out/unavailable logic is left untouched.
     */
    const ZipLock = {
      scopes: new WeakSet(),

      isLocked(scope) {
        return Array.from(scope.querySelectorAll('zip-shipping-check[data-require-zip]')).some((el) => !el.matched);
      },

      apply(scope) {
        const locked = this.isLocked(scope);
        scope.querySelectorAll(LOCK_TARGETS).forEach((target) => {
          if (locked) {
            if (!target.hasAttribute('inert')) {
              target.setAttribute('inert', '');
              target.dataset.zipInert = '';
            }
            if (!target.classList.contains('zip-locked')) target.classList.add('zip-locked');
          } else {
            if ('zipInert' in target.dataset) {
              target.removeAttribute('inert');
              delete target.dataset.zipInert;
            }
            target.classList.remove('zip-locked');
          }
        });
      },

      register(scope) {
        this.apply(scope);
        if (this.scopes.has(scope)) return;
        this.scopes.add(scope);

        // Block any add-to-cart submit (e.g. Enter in the quantity field) while locked.
        const block = (event) => {
          const form = event.target.closest?.('form');
          const isCartForm = form && (form.getAttribute('action') || '').includes('/cart/add');
          const isButton = event.type === 'click' && event.target.closest?.(LOCK_TARGETS);
          if (!(isCartForm && event.type === 'submit') && !isButton) return;
          if (!this.isLocked(scope)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          scope.querySelectorAll('zip-shipping-check[data-require-zip]').forEach((el) => el.promptForZip());
        };
        scope.addEventListener('submit', block, true);
        scope.addEventListener('click', block, true);

        // Variant changes re-render the buttons; re-apply the lock afterwards.
        new MutationObserver(() => {
          if (this.isLocked(scope)) this.apply(scope);
        }).observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['inert', 'class'] });
      },
    };

    class ZipShippingCheck extends HTMLElement {
      connectedCallback() {
        try {
          this.rules = JSON.parse(this.querySelector('[data-zip-rules]').textContent);
        } catch (e) {
          this.rules = [];
        }
        this.form = this.querySelector('[data-zip-form]');
        this.input = this.querySelector('[data-zip-input]');
        this.error = this.querySelector('[data-zip-error]');
        this.result = this.querySelector('[data-zip-result]');
        this.unavailable = this.querySelector('[data-zip-unavailable]');

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.check(this.input.value.trim());
        });
        this.input.addEventListener('input', () => {
          this.input.value = this.input.value.replace(/[^0-9a-zA-Z ]/g, '');
          this.setError('');
        });
        this.querySelectorAll('[data-zip-edit]').forEach((button) =>
          button.addEventListener('click', () => this.showForm())
        );

        this.note = this.querySelector('[data-zip-note]');
        this.matched = false;
        this.scope = this.closest('.shopify-section') || document.body;

        let saved = null;
        try {
          saved = localStorage.getItem(STORAGE_KEY);
        } catch (e) {}
        if (saved && this.isValid(saved)) {
          this.input.value = saved;
          this.check(saved, false);
        }

        ZipLock.register(this.scope);
      }

      disconnectedCallback() {
        if (this.scope) ZipLock.apply(this.scope);
      }

      promptForZip() {
        if (this.matched) return;
        if (!this.unavailable.hidden) return;
        this.showForm();
        this.note?.classList.add('zip-check__note--alert');
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      isValid(zip) {
        if (!zip) return false;
        return /^[0-9a-zA-Z ]{3,10}$/.test(zip);
      }

      matches(rule, zip) {
        const pattern = String(rule.zip).replace(/\s/g, '');
        const value = zip.replace(/\s/g, '').toUpperCase();
        const range = pattern.match(/^(\d+)-(\d+)$/);
        if (range && /^\d+$/.test(value)) {
          const n = parseInt(value, 10);
          return n >= parseInt(range[1], 10) && n <= parseInt(range[2], 10);
        }
        if (pattern.endsWith('*')) return value.startsWith(pattern.slice(0, -1).toUpperCase());
        return value === pattern.toUpperCase();
      }

      check(zip, save = true) {
        if (!this.isValid(zip)) {
          this.setError('Please enter a valid zip code.');
          return;
        }

        const rule = this.rules.find((r) => this.matches(r, zip));
        const card = rule ? this.result : this.unavailable;
        this.matched = Boolean(rule);
        if (this.scope) ZipLock.apply(this.scope);

        card.querySelector('[data-zip-value]').textContent = zip;
        if (rule) {
          card.querySelector('[data-zip-time]').textContent = rule.time || '';
        }

        this.form.hidden = true;
        this.result.hidden = card !== this.result;
        this.unavailable.hidden = card !== this.unavailable;

        if (save) {
          try {
            localStorage.setItem(STORAGE_KEY, zip);
          } catch (e) {}
        }
      }

      setError(message) {
        this.error.textContent = message;
        this.error.hidden = !message;
        this.input.setAttribute('aria-invalid', message ? 'true' : 'false');
      }

      showForm() {
        this.result.hidden = true;
        this.unavailable.hidden = true;
        this.form.hidden = false;
        this.input.focus({ preventScroll: true });
        this.input.select();
      }
    }

    customElements.define('zip-shipping-check', ZipShippingCheck);
  }
  } catch(e) { console.error(e); }
})();

})();
